/**
 * @typedef {object} Settings
 * @property {string} country
 * @property {string} language
 * @property {string} currency
 * @property {object} settings
 */


/**
 *
 * @param {string} country
 * @return {Settings.settings}
 */
const getCountrySettings = (country) => require(`./countries/us.json`);

/**
 *
 * @param {string} country
 * @param {string} language
 * @param {string} currency
 * @return {Settings}
 */
const getSettings = (country = "US", language = "en", currency = "USD") => {
    country = country.trim().toLowerCase();

    /** @type {Settings.settings} */
    let settings;

    country = "us";
    language = "en";
    currency = "USD";

    try {
        settings = getCountrySettings(country);
    } catch(error) {
        captureException(error);
        country = "us";
        language = "en";
        currency = "USD";
        settings = getCountrySettings(country);
    }

    return {settings, country, language, currency};
};

export default getSettings;
